import { Card, Heading, Icons } from '@sede-enterprise/shell-ds-react-framework';

import { useNavigate } from 'react-router';

import { rolePermissions } from 'src/constants/Permission';
import { useAppSelector } from 'src/store/hooks';
import { IFullState } from 'src/types/All.type';
import { getEnv } from 'src/utils/env.vite';
import { LandingPageContainer, TileCard, TileContent } from './style';

const { ArrowRight } = Icons;

const LandingPage = () => {
  const navigate = useNavigate();
  const isEosUser = useAppSelector(
    (state: IFullState) => state.genesisUserRolePermission.isEosUser,
  );
  const permissions = useAppSelector(
    (state: IFullState) => state.genesisUserRolePermission.permissions,
  );

  const handleGenesisClick = () => {
    navigate('/dashboard');
  };

  const handleEOSClick = () => {
    navigate('/eos/dashboard');
  };

  const handleNewGenesisClick = () => {
    navigate('/new-genesis/dashboard');
  };

  const handlePOCClick = () => {
    navigate('/poc/dashboard');
  };

  return (
    <LandingPageContainer>
      <div className='header-section'>
        <Heading type='h1'>Shell Energy</Heading>
        <p>Select the system you want to access</p>
      </div>

      <div className='main-tiles-container'>
        <TileCard onClick={handleGenesisClick} data-testid='genesis-tile'>
          <Card className='tile-card main-tile'>
            <TileContent>
              <div className='icon-section'>
                <div className='genesis-icon'>G</div>
              </div>
              <div className='content-section'>
                <Heading type='h3'>Genesis</Heading>
                <p>
                  Access Genesis gas operations management system including nominations,
                  allocations, and trading operations
                </p>
                <div className='arrow-section'>
                  <ArrowRight />
                </div>
              </div>
            </TileContent>
          </Card>
        </TileCard>
        {isEosUser && (
          <TileCard onClick={handleEOSClick} data-testid='eos-tile'>
            <Card className='tile-card main-tile'>
              <TileContent>
                <div className='icon-section'>
                  <div className='eos-icon'>EOS</div>
                </div>
                <div className='content-section'>
                  <Heading type='h3'>Energy Offtake Solution</Heading>
                  <p>
                    Energy Operations System for managing supply contracts and scenario analysis
                    across European markets
                  </p>
                  <div className='arrow-section'>
                    <ArrowRight />
                  </div>
                </div>
              </TileContent>
            </Card>
          </TileCard>
        )}
        {(getEnv('VITE_APP_ENVIRONMENT') === 'Dev' ||
          getEnv('VITE_APP_ENVIRONMENT') === 'Preprod') && (
          <TileCard onClick={handleNewGenesisClick} data-testid='new-genesis-tile'>
            <Card className='tile-card main-tile'>
              <TileContent>
                <div className='icon-section'>
                  <div className='new-genesis-icon'>NG</div>
                </div>
                <div className='content-section'>
                  <Heading type='h3'>New Genesis</Heading>
                  <p>Next generation operations including flat deals and system administration</p>
                  <div className='arrow-section'>
                    <ArrowRight />
                  </div>
                </div>
              </TileContent>
            </Card>
          </TileCard>
        )}{' '}
      </div>
    </LandingPageContainer>
  );
};

export default LandingPage;
